import moment from "moment";
import { memo, useMemo } from "react";

import TitleValue from "../TitleValue";
import Helpers from "../../commons/helpers";
import DatePickerRoot from "./DatePickerRoot";

import { Mode } from "../../constants/enums";

type IDateView = "year" | "month" | "day";
interface Props {
    mode?: number;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    isFullRow?: boolean;
    placeholder?: string;
    variant?: "standard" | "outlined";

    value?: any;
    minDate?: any;
    maxDate?: any;
    views?: IDateView[];
    errorMessage?: string;
    onChangeValue?: (value: any) => void;
}

const DatePicker: React.FC<Props> = ({
    mode,
    label,
    views,
    variant,
    required,
    disabled,
    isFullRow,
    placeholder,
    errorMessage,
    onChangeValue,
    ...rest
}: Props) => {
    const value = useMemo(
        () => (Helpers.isNullOrEmpty(rest.value) || rest.value === "0" || rest.value === 0 ? undefined : moment(rest.value)),
        [rest.value]
    );

    if (mode === Mode.View) {
        return <TitleValue title={label} isFullRow={isFullRow} value={Helpers.formatDate(value ? value.toDate() : "")} />;
    }

    return (
        <DatePickerRoot
            {...rest}
            views={views}
            value={value}
            disabled={disabled}
            key={label}
            dayOfWeekFormatter={(day: any) => `${day}`}
            label={`${label || ""} ${required ? "*" : ""}`}
            onChange={(newValue: any) => {
                Helpers.isFunction(onChangeValue) && onChangeValue(newValue);
            }}
            ownerState={{
                disabled,
                variant: variant || "standard",
                error: !Helpers.isNullOrEmpty(errorMessage),
            }}
            sx={{ width: "100%" }}
            slotProps={{
                textField: { helperText: errorMessage },
            }}
        />
    );
};

DatePicker.defaultProps = {
    disabled: false,
};

export default DatePicker;
